import { createElement } from 'react';
import type { IntakeCounty } from '../api/newClient.ts';

/**
 * The county of the proceeding on the new-client form: exactly the counties
 * `GET /intake-counties` returns, in its order, and nothing written here
 * (Arthur, 21 October, 13:12). While the list is loading, or if it failed, the
 * one option says so, and the form cannot be sent without a county.
 */
export function CountySelect(props: {
  id: string;
  className: string;
  value: string;
  onChange: (code: string) => void;
  counties: readonly IntakeCounty[] | undefined;
  failed?: boolean;
}) {
  const { counties } = props;
  const first = counties ? 'Choose…' : props.failed ? 'Counties could not be loaded' : 'Loading counties…';
  return createElement(
    'select',
    {
      id: props.id, required: true, value: props.value, className: props.className,
      onChange: (e: { target: { value: string } }) => props.onChange(e.target.value),
    },
    createElement('option', { value: '' }, first),
    ...(counties ?? []).map((c) => createElement('option', { key: c.code, value: c.code }, c.label)),
  );
}
